// Body of the lookup-orders-by-email ("Check Your Order Status") page: the
// legacy stearns account-page layout -- the brand heading, the email form
// rendered as a native React field tree, and the decorative account image. The
// help / heading copy is the stearns legacy template's own; stearns serves
// en-us only, so the plain literals match the legacy {% trans %} /
// {% blocktrans %} output.
import { Immutable } from "immer";
import React from "react";
import { FormFields } from "tsi-common-react/src/apps/customer-account/FormFields/index";
import {
    FORM_FIELD_SUBMIT_CLASS_NAME,
    FORM_HELP_TEXT_CLASS_NAME,
} from "tsi-common-react/src/forms/classNames";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

type IProps = Immutable<templates.LookupOrdersByEmailDocumentTemplate>;

export const LookupOrdersByEmailBody = (props: IProps): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <div className="l-capped-width">
            <header>
                <h1>Your Stearns &amp; Foster® Orders</h1>
            </header>

            <section className="account-page-container">
                <div>
                    <h2>Check Your Order Status</h2>
                    <div>
                        <form
                            id="lookup-orders-by-email-form"
                            className="js-kuid-form"
                            action={props.action_url}
                            method="post"
                        >
                            <p
                                className={FORM_HELP_TEXT_CLASS_NAME}
                                data-testid="form-help-text"
                            >
                                Please enter the email address associated with
                                your order. If we&rsquo;re able to locate an
                                order associated with your email address,
                                we&rsquo;ll send you a link to access your order
                                history.
                            </p>
                            <CSRFToken />
                            <FormFields
                                fields={props.fields}
                                field_labels={props.field_labels}
                                field_errors={props.field_errors}
                                non_field_errors={props.non_field_errors}
                            />
                            <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                                <input
                                    type="submit"
                                    className="button button--full-width"
                                    value="Send Verification Email"
                                />
                            </div>
                        </form>
                    </div>
                </div>
                <div>
                    {/* Decorative image: empty alt attr */}
                    <img
                        src={`${staticURL}img/accounts/accounts-page-img.jpg`}
                        alt=""
                    />
                </div>
            </section>
        </div>
    );
};
